import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-trial-insights-header',
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './trial-insights-header.component.html',
})
export class TrialInsightsHeaderComponent {
  @Input() color = '';
  @Input() header = '';
  @Input() title = '';
}
